import React from 'react';
import { Helmet } from 'react-helmet';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import ClientPage from './pages/ClientPage';
import PractitionerPage from './pages/PractitionerPage';
import './i18n';
import AccessDenied from './pages/AccessDenied';
import InvalidSession from './pages/InvalidSession';
import PractitionerControlsProvider from './components/PractionerControlsProvider';

const APP_TITLE = 'Psylaris';

export default function App() {
  return (
    <>
      <Helmet>
        <title>{APP_TITLE}</title>
      </Helmet>
      <Router>
        <Switch>
          <Route path="/ClientPage">
            <PractitionerControlsProvider>
              <ClientPage name={'Client Page'} />
            </PractitionerControlsProvider>
          </Route>
          <Route path="/PractitionerPage">
            <PractitionerPage name={'Practitioner Page'} />
          </Route>
          <Route path="/access-denied">
            <AccessDenied />
          </Route>
          <Route path="/invalid-session">
            <InvalidSession />
          </Route>
        </Switch>
      </Router>
    </>
  );
}
